export default __webpack_public_path__ + "static/media/cevre-tescil.ed28aaa2.jpeg";